// NOTE: these are meant to be a one-of constants that don't fit with any enumeration
// NOTE: do not make more files like this one

export const STYLE_DISPLAY_NONE = Object.freeze({ display: 'none' });

export const IGNORE = Symbol('Ignore the entry');
export const DELETE = Symbol('Delete the value');

export const NO_MEDIA_TYPE = Symbol('Do not use media type');

export const BYPASS = Symbol('Execution is bypassed');
